import { create } from 'zustand';
import { createCartItemSlice, type CartItemSlice } from './cartItemSlice';
import { createCartPromoSlice, type CartPromoSlice } from './cartPromoSlice';
import { createCartCalculateSlice, type CartCalculateSlice } from './cartCalculateSlice';
import { createCartShippingSlice, type CartShippingSlice } from './cartShippingSlice';

export const useCartStore = create<
    CartItemSlice & CartCalculateSlice & CartPromoSlice & CartShippingSlice
>()((...a) => ({
    ...createCartItemSlice(...a),
    ...createCartCalculateSlice(...a),
    ...createCartPromoSlice(...a),
    ...createCartShippingSlice(...a),
}));

export type { CartItemSlice, CartCalculateSlice, CartPromoSlice, CartShippingSlice };
